import { toJson } from "src/utils/string/toJson";
import {
  COMPLETED_SUMMARY_STATUS_LABEL,
  LOAD_SKILL_BODY_ERROR_PATTERN,
  LOAD_SKILL_TOOL_NAME,
  RESULT_STATUS_STYLES,
  type ToolCallResultStatus,
} from "./ToolCallIndicator.constants";

/** True when tool is load_skill and body matches known failure phrases (case-insensitive). */
export function isLoadSkillFailureIndicatedByBody(
  toolName: string,
  body: string
): boolean {
  return (
    toolName === LOAD_SKILL_TOOL_NAME && LOAD_SKILL_BODY_ERROR_PATTERN.test(body)
  );
}

export function toolCallInputDisplayText(
  input: Record<string, unknown>,
  hasInputParseError?: boolean
): string {
  if (hasInputParseError && input.__raw__) return String(input.__raw__);
  return JSON.stringify(input, null, 2);
}

export function resolveResultStatus(
  isError: boolean,
  isEmpty: boolean
): ToolCallResultStatus {
  if (isError) return "error";
  if (isEmpty) return "empty";
  return "success";
}

function prettyPrintBody(body: string): string {
  if (!body.trim()) return "No output";
  return toJson(body);
}

export function getToolCallCompletedPresentation(
  name: string,
  body: string,
  isError: boolean | undefined
) {
  const loadSkillBodyError = isLoadSkillFailureIndicatedByBody(name, body);
  const effectiveError = Boolean(isError) || loadSkillBodyError;
  const isEmpty = !body.trim();
  const resultStatus = resolveResultStatus(effectiveError, isEmpty);
  const styles = RESULT_STATUS_STYLES[resultStatus];
  const statusText = COMPLETED_SUMMARY_STATUS_LABEL[resultStatus];
  const formattedBody = isEmpty && !effectiveError ? "" : prettyPrintBody(body);

  return {
    effectiveError,
    isEmpty,
    formattedBody,
    statusText,
    styles,
  };
}
